'use client';

import { publicTrialHref } from 'src/utils/guest/public-entry';

import { useAuthContext } from 'src/auth/hooks';

/**
 * 공개 지면의 「무료로 시작하기」가 가는 곳 — 로그인했으면 서비스(`/service`), 아니면 로그인 화면(간편가입 포함 · 돌아올 곳 = 서비스 홈).
 * ⚠️ 인증이 풀리기 전에는 비회원 쪽이다 — 로그인한 사람이 그 사이에 눌러도 로그인 화면이 서비스로 다시 보낸다.
 */
export function usePublicTrialHref(): string {
  const { authenticated, loading } = useAuthContext();
  return publicTrialHref(!loading && authenticated === true);
}
